import React from 'react';
import { Select } from 'antd';
import { allDimensionsListSelector } from '@store/common/dimensionList/selectors';
import { useDispatch, useSelector } from 'react-redux';
import { updateDimension } from '@store/trends/base/actions';
import { StyledSelector } from './styled';
import useContainerRef from '@src/hooks/utils/useContainerRef';

function DimensionSelector({ dimension, disabled = false }) {
  const dimensions = useSelector(allDimensionsListSelector);
  const dispatch = useDispatch();

  const handleChange = (newDimension) => {
    dispatch(updateDimension(dimension, newDimension));
  };

  const options = dimensions.map(d => ({
    label: d.name,
    value: d.groupBy,
  }))
  options.sort((a, b) => a.label.localeCompare(b.label));

  const { containerRef, getContainer } = useContainerRef();

  return (
    <StyledSelector ref={containerRef} >
      <Select
        showSearch
        options={options}
        optionFilterProp='label'
        value={dimension}
        onChange={handleChange}
        style={{
          width: 280,
          fontSize: '18px',
        }}
        bordered={false}
        disabled={disabled}
        dropdownStyle={{ minWidth: 280 }}
        getPopupContainer={getContainer}
      />
    </StyledSelector>
  );
}

export default DimensionSelector;
